import _ from "lodash";
import { IBudgetAllocForm, IItemToRequest } from "src/app/shared/models/app-models";
import { BudgetAllocationSummary, GeneralForm } from "src/app/shared/models/app-models/MyPurchaseForm.model";
import { totalAmountCalculation, totalAORExemptedAmountCalculation,budgetInformation, totalAmountCalculationAO, totalAORExemptedAmountCalculationAO } from "src/app/modules/shared/utils/return-budget-calculation";
export const getOperatingBudgetAllocationsCWithFinancialYearForRO = (allBudgetAllocationForms: IBudgetAllocForm[], itemList: IItemToRequest[]): BudgetAllocationSummary[] => {
    let itemIdList = itemList.filter(x => !x.isDeleted).map(x => x.AddItems.itemId).sort()
    let ballocation: any[] = budgetInformation(allBudgetAllocationForms, itemList);
    let budgetCount = 0
    let budgetGroup = _.groupBy(
        ballocation.filter(
            (s) => s.BudgetType.value === 'Operating' && !s.isDeleted && !s.Strikethrough
        ),
        (allo) =>
            (allo.CostCentre?.value ?? '') +
            (allo.OrderNo?.value ?? '') + (allo.GLAcc?.value ?? '') +
            (allo.BudgetExpenditureUsage?.value ?? '') +
            (allo.BudgetFrequencyUsage?.value ?? '') + allo.FinancialYear
    );
    let result = _.map(budgetGroup, (allocation, key) => {

        let totalAmount = totalAmountCalculationAO(allocation, itemList);
        let totalAORExemptedAmount = totalAORExemptedAmountCalculationAO(allocation, itemList);
        budgetCount++;
        return {
            budgetType: allocation[0].BudgetType?.value ?? '',
            costCentre: allocation[0].CostCentre?.value ?? '',
            glAccount: allocation[0].GLAcc?.value,
            costCentreId: allocation[0].CostCentre?.id ?? '',
            glAccountId: allocation[0].GLAcc?.id,
            orderNo: allocation[0].OrderNo?.value ?? '',
            budgeted: allocation[0].BudgetExpenditureUsage?.value ?? '',
            reccurent: allocation[0].BudgetFrequencyUsage?.value ?? '',
            percentage: allocation.reduce(
                (sum, allo) => sum + (allo.Percentage ?? 1),
                0
            ),
            id: allocation[0].purchaseItemNo,
            projectBudget: '',
            totalAmount: Math.round(totalAmount * 100) / 100,
            fundCentre: '',
            budgetId: budgetCount.toString(),
            projectCode: '',
            aorExemptedAmount: Math.round(totalAORExemptedAmount * 100) / 100,
            aorAmount: Math.round((totalAmount - totalAORExemptedAmount) * 100) / 100,
            personnel: '',
            personnelOptions: undefined,
            Strikethrough: allocation[0].Strikethrough,
            displayPurchaseItemNumber: allocation[0].purchaseItemNo,
            FinancialYear: allocation[0].FinancialYear,
            EndFinancialYear: allocation[0].EndFinancialYear
        } as BudgetAllocationSummary;
    });
    return result;
}

export const getCapitalBudgetAllocationsWithFinancialYearForRO = (allBudgetAllocationForms: IBudgetAllocForm[], itemList: IItemToRequest[]): BudgetAllocationSummary[] => {
    let itemIdList = itemList.filter(x => !x.isDeleted).map(x => x.AddItems.itemId).sort((a, b) => a - b);
    let ballocation: any[] = budgetInformation(allBudgetAllocationForms, itemList);
    let budgetGroup = _.groupBy(
        ballocation.filter((s) => s.BudgetType.value === 'Capital' && !s.isDeleted && !s.Strikethrough),
        (allo) =>
            (allo.FundCentre?.value ?? '') + (allo.GLAcc?.value ?? '') +
            (allo.OrderNo?.value ?? '') + 
            (allo.BudgetExpenditureUsage?.value ?? '') + allo.FinancialYear
    );

    let result = _.map(budgetGroup, (allocation, key) => {
        let totalAmount = totalAmountCalculationAO(allocation, itemList);
        return {
            budgetType: allocation[0].BudgetType?.value ?? '',
            costCentre: allocation[0].CostCentre?.value ?? '',
            glAccount: allocation[0].GLAcc?.value ?? '',
            costCentreId: allocation[0].CostCentre?.id ?? '',
            glAccountId: allocation[0].GLAcc?.id,
            orderNo: allocation[0].OrderNo?.value ?? '',
            budgeted: allocation[0].BudgetExpenditureUsage?.value ?? '',
            wbsElement: allocation[0].ProjectBudget?.id ?? '',
            reccurent: allocation[0].BudgetFrequencyUsage?.value ?? '',
            percentage: allocation.reduce(
                (sum, allo) => sum + (allo.Percentage ?? 1),
                0
            ),
            id: allocation[0].PurchaseItemNo ?? '',
            projectBudget: '',
            totalAmount: Math.round(totalAmount * 100) / 100,
            fundCentre: allocation[0].FundCentre?.value ?? '',
            budgetId: '',
            projectCode: '',
            aorExemptedAmount: 0,
            aorAmount: Math.round(totalAmount * 100) / 100,
            personnel: '',
            personnelOptions: undefined,
            Strikethrough: allocation[0].Strikethrough,
            displayPurchaseItemNumber: allocation[0].PurchaseItemNo ?? '',
            FinancialYear: allocation[0].FinancialYear,
            EndFinancialYear: allocation[0].EndFinancialYear
        };
    });

    return result;
}

export const getProjectBudgetAllocationsForRO = (
    allBudgetAllocationForms: IBudgetAllocForm[], itemlist: IItemToRequest[], genForm: GeneralForm
): Promise<BudgetAllocationSummary>[] => {
    let itemIdList = itemlist.filter(x => !x.isDeleted).map(x => x.AddItems.itemId).sort()
    let budgetGroup = _.groupBy(
        allBudgetAllocationForms.filter((s) => s.BudgetType.value === 'Project' && !s.isDeleted && !s.Strikethrough),
        (allo) =>
            (allo.ProjectCode?.id ?? '') + 
            (allo.ProjectBudget?.id ?? '') + allo.GLAcc + allo.Strikethrough
    )
    let result = _.map(budgetGroup, async (allocation, key) => {

        let totalAmount = totalAmountCalculationAO(allocation, itemlist);
        let approvingPersonnels = []
        const purchaseItemNo = allocation
            .map(allo => allo.PurchaseItemNo)
            .filter((value, index, self) => self.indexOf(value) === index).map(x => itemIdList.indexOf(x!) + 1)
            .join(', ');
        const displayedPurchaseItemNo = allocation.map(allo => allo.displayPurchaseItemNumber).join(', ');

        return {
            budgetType: allocation[0].BudgetType?.value ?? '',
            glAccount: allocation[0].GLAcc?.value ?? '',
            id: purchaseItemNo,
            projectBudget: allocation[0].ProjectBudget?.value ?? '',
            totalAmount: Math.round(totalAmount * 100) / 100,
            projectCode: allocation[0].ProjectCode?.id ?? '',
            costCentre: '',
            orderNo: '',
            budgeted: '',
            reccurent: '',
            percentage: 0,
            fundCentre: '',
            budgetId: '',
            aorExemptedAmount: 0,
            aorAmount: Math.round(totalAmount * 100) / 100,
            personnel: allocation[0].ApprovingOfficer
                ?? '',
            personnelOptions: [],
            Strikethrough: allocation[0].Strikethrough,
            displayPurchaseItemNumber: displayedPurchaseItemNo
        };
    });
    return result;
}


export const getCapitalAUCAllocationsForRO = (allBudgetAllocationForms: IBudgetAllocForm[], itemList: IItemToRequest[]): BudgetAllocationSummary[] => {
    let itemIdList = itemList
        .filter(x => !x.isDeleted && !x.Strikethrough)
        .map(x => x.AddItems.itemId)
        .sort((a, b) => a - b);
    let budgetGroup = _.groupBy(
        allBudgetAllocationForms.filter(
            (s) => s.BudgetType.value === 'Capital AUC' && !s.isDeleted && !s.Strikethrough
        ),
        (allo) =>
            (allo.BudgetExpenditureUsage?.value ?? '') +
            (allo.ProjectBudget?.id ?? '') + (allo.GLAcc?.value ?? '')
    );
    let result = _.map(budgetGroup, (allocation, key) => {
        let totalAmount = totalAmountCalculationAO(allocation, itemList);
        const purchaseItemNo = allocation
            .map(allo => allo.PurchaseItemNo)
            .filter((value, index, self) => self.indexOf(value) === index).map(x => itemIdList.indexOf(x!) + 1)
            .join(', ');
        const displayedItemNo = allocation
            .map(allo => allo.displayPurchaseItemNumber).join(', ');
        return {
            budgetType: allocation[0].BudgetType?.value ?? '',
            glAccount: allocation[0].GLAcc?.value ?? '',
            budgeted: allocation[0].BudgetExpenditureUsage?.value ?? '',
            percentage: allocation.reduce(
                (sum, allo) => sum + (allo.Percentage ?? 1),
                0
            ),
            id: purchaseItemNo,
            totalAmount: Math.round(totalAmount * 100) / 100,
            projectBudget: allocation[0].ProjectBudget?.value ?? '',
            wbsElement: allocation[0].ProjectBudget?.id ?? '',
            fundCentre: '',
            costCentre: '',
            orderNo: '',
            reccurent: '',
            budgetId: '',
            projectCode: '',
            personnel: '',
            aorExemptedAmount: 0,
            aorAmount: 0,
            personnelOptions: undefined,
            Strikethrough: allocation[0].Strikethrough,
            displayPurchaseItemNumber: displayedItemNo
        };
    });
    return result;
}

export const getCapitalAllocations = (allBudgetAllocationForms: IBudgetAllocForm[], itemList: IItemToRequest[]): BudgetAllocationSummary[] => {
    let itemIdList = itemList
        .filter(x => !x.isDeleted && !x.Strikethrough)
        .map(x => x.AddItems.itemId)
        .sort((a, b) => a - b);
    let budgetGroup = _.groupBy(
        allBudgetAllocationForms.filter(
            (s) => s.BudgetType.value !== 'Operating' && !s.isDeleted && !s.Strikethrough
        ),
        (allo) =>
            (allo.BudgetExpenditureUsage?.value ?? '') +
            (allo.ProjectBudget?.id ?? '') + (allo.GLAcc?.value ?? '')
    );
    let result = _.map(budgetGroup, (allocation, key) => {
        let totalAmount = totalAmountCalculation(allocation, itemList);
        const purchaseItemNo = allocation
            .map(allo => allo.PurchaseItemNo)
            .filter((value, index, self) => self.indexOf(value) === index).map(x => itemIdList.indexOf(x!) + 1)
            .join(', ');
        const displayedItemNo = allocation
            .map(allo => allo.displayPurchaseItemNumber).join(', ');
        return {
            budgetType: allocation[0].BudgetType?.value ?? '',
            glAccount: allocation[0].GLAcc?.value ?? '',
            budgeted: allocation[0].BudgetExpenditureUsage?.value ?? '',
            percentage: allocation.reduce(
                (sum, allo) => sum + (allo.Percentage ?? 1),
                0
            ),
            id: purchaseItemNo,
            totalAmount: Math.round(totalAmount * 100) / 100,
            projectBudget: allocation[0].ProjectBudget?.value ?? '',
            wbsElement: allocation[0].ProjectBudget?.id ?? '',
            fundCentre: '',
            costCentre: '',
            orderNo: '',
            reccurent: '',
            budgetId: '',
            projectCode: '',
            personnel: '',
            aorExemptedAmount: 0,
            aorAmount: 0,
            personnelOptions: undefined,
            Strikethrough: allocation[0].Strikethrough,
            displayPurchaseItemNumber: displayedItemNo
        };
    });
    return result;
}
